// Shared across every proposal: First Look and the Listing Blitz.
// Edit here once; every client's page picks it up.

export const launch = {
  intro: "A launch built to create momentum.",
  subIntro: "Two optional programs I use to bring a home to market.",
  firstLook: {
    lead: "NWMLS now offers an optional First Look status before a home goes Active.",
    bigNumber: "Up to 21 days",
    bigNumberLabel: "before days on market begin",
    tiles: [
      { title: "You choose", text: "Showings, photos and online exposure." },
      { title: "Learn and adjust", text: "Gather feedback. Refine price or presentation." },
      { title: "Build momentum", text: "Create early interest with a coordinated launch." },
    ],
    footnote: "NWMLS retains First Look time and price history.",
  },
  blitz: {
    title: "The Listing Blitz",
    days: [
      { day: "Wednesday", title: "Introduce the home", text: "First Look goes live online." },
      { day: "Thursday to Friday", title: "Promote the home", text: "No showings yet." },
      {
        day: "Saturday at 2 PM",
        title: "Open the doors",
        text: "The home goes Active. Open house, buyer tours and agent showings start together.",
      },
    ],
    footnote: "Showings continue after opening. Timing reflects your home and the market.",
  },
};
